import { store } from 'redux/store';

import downloadWord from 'utils/downloadWord';
import previewDownload from 'utils/previewDownload';

import { setModal } from 'modules/_shared/redux/modalActions';
import boardTemplateTypes from 'modules/boards/constants/boardTemplateTypes';
import ReplaceBoardTemplate from 'modules/boards/modals/ReplaceBoardTemplate';
import ReplaceTemplateWithDocumentModal from 'modules/boards/modals/ReplaceTemplateWithDocumentModal';

function menuOptions(i18n) {
  return [
    {
      id: 'download-pdf',
      icon: 'ni-file-pdf',
      text: i18n.t('DownloadPDF'),
      action: previewDownload,
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      id: 'download-word',
      icon: 'ni-file-doc',
      text: i18n.t('DownloadWord'),
      action: ({ preview }) =>
        downloadWord(preview.documentModel, preview.name),
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      id: 'edit-template',
      icon: 'ni-edit',
      text: i18n.t('Edit'),
      action: ({ setShowEditor }) => setShowEditor(true),
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      id: 'change-template',
      icon: 'ni-files',
      text: i18n.t('ChangeTemplate'),
      action: ({ board }) =>
        store.dispatch(
          setModal(
            <ReplaceBoardTemplate
              board={board}
              templateType={boardTemplateTypes.ACT}
            />
          )
        ),
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      id: 'replace-act',
      icon: 'ni-upload',
      text: i18n.t('ReplaceAct'),
      action: ({ board }) => {
        store.dispatch(
          setModal(
            <ReplaceTemplateWithDocumentModal
              boardId={board._id}
              templateType={boardTemplateTypes.ACT}
            />
          )
        );
      },
      disabled: false,
    },
    {
      id: 'replace-act',
      icon: 'ni-upload',
      text: i18n.t('ReplaceAct'),
      action: ({ board }) => {
        store.dispatch(
          setModal(
            <ReplaceTemplateWithDocumentModal
              boardId={board._id}
              templateType={boardTemplateTypes.ACT}
            />
          )
        );
      },
      disabled: false,
    },
  ];
}
export default menuOptions;
